import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    // Legacy route — redirect to root which handles OIDC
    throw redirect({ to: '/' })
  },
  component: () => null,
})
